import { render, staticRenderFns } from "./AdvertisingList.vue?vue&type=template&id=3b8936c4&scoped=true"
import script from "./AdvertisingList.vue?vue&type=script&lang=js"
export * from "./AdvertisingList.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingList.vue?vue&type=style&index=0&id=3b8936c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8936c4",
  null
  
)

export default component.exports